export { default } from './modal-beeper';
